import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { BOLD_FONT_FAMILY } from '../constants/constants';
import { CloseIcon } from '../icons/closeIcon';
import { DEFAULT_BACKGROUND_COLOR, MODAL_HEADER_BACKGROUND_COLOR } from '../styles/colors';
const DIALOG_TITLE_CSS = css `
  background-color: ${MODAL_HEADER_BACKGROUND_COLOR};
  box-shadow: 0px -2px 0px 0px ${DEFAULT_BACKGROUND_COLOR} inset;
`;
const CONTAINER_CSS = css `
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-flow: row wrap;
`;
const TITLE_CONTAINER_CSS = css `
  flex-grow: 1;
`;
const TYPOGRAPHY_CSS = css `
  font-size: 120%;
  font-family: ${BOLD_FONT_FAMILY};
  filter: drop-shadow(3px 3px 0 rgba(0, 0, 0, 0.2));
  line-height: 1.25;
`;
/**
 * If there are no 'additional' controls, show the close button positioned relative to the top right corner of the modal,
 * and don't allow it to wrap to below the title, which looks bad.
 */
export const ModalHeaderContainer = ({ title, onClose, additionalControls }) => {
    if (!title) {
        return null;
    }
    return (_jsx(DialogTitle, { css: DIALOG_TITLE_CSS, children: _jsxs("div", { css: CONTAINER_CSS, style: !additionalControls ? { position: 'relative' } : undefined, children: [_jsx("div", { css: TITLE_CONTAINER_CSS, style: !additionalControls ? { paddingRight: '32px' } : undefined, children: _jsx(Typography, { variant: 'h6', css: TYPOGRAPHY_CSS, children: title }) }), _jsxs("div", { style: !additionalControls
                        ? {
                            position: 'absolute',
                            right: '-20px',
                            top: '-10px'
                        }
                        : undefined, children: [additionalControls, onClose && (_jsx(IconButton, { "aria-label": 'Close', onClick: onClose, size: 'large', children: _jsx(CloseIcon, {}) }))] })] }) }));
};
